import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ExportListItem from './ExportListItem';

export default class ExportListItems extends Component {

  handleSelection = (selectedElementId, clearExisting, shiftKey) => {
    this.props.handleSelection(selectedElementId, clearExisting, shiftKey);
  };

  renderLeftList = type => {
    const listArr = [];
    this.props.items.map(item => {
      if (item.type === type) {
        item.selected =
          this.props.selectedItems &&
          this.props.selectedItems.indexOf(item.id) >= 0;

        listArr.push(
          <ExportListItem
            key={item.id}
            {...item}
            handleSelection={this.handleSelection}
            type={item.type}
            pane={this.props.pane}
          />
        );
      }
      return null;
    });
    return listArr;
  }

  render() {
    const renderList = () =>
      this.props.items.map(item => {
        item.selected =
          this.props.selectedItems &&
          this.props.selectedItems.indexOf(item.id) >= 0;
        return (
          <ExportListItem
            key={item.id}
            {...item}
            handleSelection={this.handleSelection}
            type={item.type}
            pane={this.props.pane}
          />
        );
      });
    if (this.props.pane === 'left') {
      return (
        <div className="multi-select-export-list">
          <ul
            className="vertical dropdown menu user-select-none"
            data-dropdown-menu
          >
            <div className="user-defined-export-heading">USER-DEFINED</div>
            {this.renderLeftList('user')}
            <div className="standard-export-heading">STANDARD</div>
            {this.renderLeftList('standard')}
          </ul>
        </div>
      );
    } else {
      return (
        <div className="multi-select-export-list">
          <ul
            className="vertical dropdown menu user-select-none"
            data-dropdown-menu
          >
            {renderList()}
          </ul>
        </div>
      );
    }
  }
}

ExportListItems.propTypes = {
  pane: PropTypes.string,
  handleSelection: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.object),
  selectedItems: PropTypes.arrayOf(PropTypes.object),
};
